import React from 'react';
import { BsEggFried } from 'react-icons/bs';
import SidebarFlyoutNavRow from './SidebarFlyoutNavRow';
import { ADMIN_FLYOUT_IDS } from './SidebarFlyoutContext';
import { buildCateringFlyoutItems, CATERING_CHILD_ROUTES } from './catering/cateringNavConfig';

function CateringFlyoutRow({ SubMenuItem, hasMenuAccess, closeMobileSidebar, indentClass = 'ps-5' }) {
  const items = buildCateringFlyoutItems(hasMenuAccess);
  if (items.length === 0) return null;

  return (
    <SidebarFlyoutNavRow
      flyoutId={ADMIN_FLYOUT_IDS.catering}
      label="Catering"
      flyoutTitle="Catering"
      items={items}
      SubMenuItem={SubMenuItem}
      closeMobileSidebar={closeMobileSidebar}
      indentClass={indentClass}
      alwaysFlyout
    />
  );
}

function CateringNavContent({ SubMenuItem, hasMenuAccess, closeMobileSidebar }) {
  return (
    <>
      {hasMenuAccess('/catering/estimator') && <SubMenuItem to="/catering/estimator">Cost Estimator</SubMenuItem>}
      {hasMenuAccess('/catering/food-items') && <SubMenuItem to="/catering/food-items">Food Items</SubMenuItem>}
      {hasMenuAccess('/catering/rations') && <SubMenuItem to="/catering/rations">Ration Templates</SubMenuItem>}
      {hasMenuAccess('/catering/estimates') && <SubMenuItem to="/catering/estimates">Saved Estimates</SubMenuItem>}
    </>
  );
}

/**
 * Catering block for the desktop sidebar (NavigationBar).
 * Under Administration: single flyout row (Drilling → Budget pattern).
 */
function CateringNavSection({
  MenuItem,
  SubMenuItem,
  hasMenuAccess,
  hasMenuAccessOrChild,
  closeMobileSidebar,
  nested = false,
}) {
  if (!hasMenuAccessOrChild('/catering', CATERING_CHILD_ROUTES)) {
    return null;
  }

  if (nested) {
    return (
      <CateringFlyoutRow
        SubMenuItem={SubMenuItem}
        hasMenuAccess={hasMenuAccess}
        closeMobileSidebar={closeMobileSidebar}
        indentClass="ps-5"
      />
    );
  }

  return (
    <MenuItem customIcon={<BsEggFried style={{ width: '24px', height: '24px' }} />} title="Catering" id="catering">
      <CateringNavContent SubMenuItem={SubMenuItem} hasMenuAccess={hasMenuAccess} />
    </MenuItem>
  );
}

export default CateringNavSection;
